import React from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import { CrudForm, TextField, useEntityManager, Checkbox } from 'elentari'
import unidadeNegocioRepository from './unidadeNegocioRepository'
import EmpresaSelect from '../Empresa/EmpresaSelect'
import * as yup from 'yup'
import yupValidation from '../../lib/yupValidation'

const motoristaSchema = yup.object().shape({
  motorista: yup.object().shape({
    descricao: yup
      .string()
      .trim()
      .nullable(true)
      .required('Obrigatório'),
    empresaId: yup
      .string()
      .trim()
      .nullable(true)
      .required('Obrigatório'),
    status: yup
      .string()
      .trim()
      .nullable(true)
      .required('Obrigatório')
  })
})

export const validateMotorista = yupValidation(motoristaSchema)

const UnidadeNegocioForm = props => {
  const entityManager = useEntityManager({
    repository: unidadeNegocioRepository,
    initialData: {
      status: true
    }
  })
  return (
    <CrudForm {...props} {...entityManager} withPaper>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Field
            fullWidth
            name="descricao"
            label="Descrição"
            component={TextField}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <EmpresaSelect />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Field
            fullWidth
            name="status"
            label="Ativo"
            component={Checkbox}
            type="checkbox"
          />
        </Grid>
      </Grid>
    </CrudForm>
  )
}

export default UnidadeNegocioForm
